var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-260 340.5 90 112.5",
    style: {
      enableBackground: "new -260 340.5 90 112.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#2B5F43;stroke-width:2.8346;stroke-miterlimit:10;}\r\n\t.st1{fill:#2B5F43;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-181.1,451.6h-67.9c-5.5,0-10-4.5-10-10v-89.8c0-5.5,4.5-10,10-10h67.9c5.5,0,10,4.5,10,10v89.8 C-171.1,447.1-175.4,451.6-181.1,451.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-193.3,406.8L-193.3,406.8c0-5.3-3.9-8.4-8.6-8.4l0,0c0-5.6-3.9-8.4-8.6-8.4h-8.6c-4.7,0-8.6,2.8-8.6,8.4l0,0 c-4.7,0-8.6,3.1-8.6,8.4l0,0c-4.9,0-8.6,4.2-8.6,9.1s3.9,9.1,8.6,9.1h43.5c4.9,0,8.6-4.2,8.6-9.1 C-184.3,411-188.3,406.8-193.3,406.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-214.8,375.4c0,1.5-1.3,2.7-1.3,2.7c-0.7,0.7-0.8,1.8-0.1,2.5c0.3,0.4,0.8,0.6,1.3,0.6s0.8-0.1,1.1-0.4 s2.4-2.2,2.4-5.2c0-2-0.7-3.6-2.4-5.3c-2.8-2.8-0.4-5.3,0-5.9c0.7-0.7,0.7-1.8,0-2.5s-1.8-0.7-2.5,0c-2.1,2.1-3.9,6.8,0,10.7 C-215.3,373.6-214.8,374.5-214.8,375.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-197.4,385.8c0,1.5-1.3,2.7-1.3,2.7c-0.7,0.7-0.8,1.8-0.1,2.5c0.3,0.4,0.8,0.6,1.3,0.6s0.8-0.1,1.1-0.4 s2.4-2.2,2.4-5.2c0-2-0.7-3.6-2.4-5.3c-2.8-2.8-0.4-5.3,0-5.9c0.7-0.7,0.7-1.8,0-2.5s-1.8-0.7-2.5,0c-2.1,2.1-3.9,6.8,0,10.7 C-197.8,384-197.4,385-197.4,385.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-232.3,385.8c0,1.5-1.3,2.7-1.3,2.7c-0.7,0.7-0.8,1.8-0.1,2.5c0.3,0.4,0.8,0.6,1.3,0.6c0.4,0,0.8-0.1,1.1-0.4 s2.4-2.2,2.4-5.2c0-2-0.7-3.6-2.4-5.3c-2.8-2.8-0.4-5.3,0-5.9c0.7-0.7,0.7-1.8,0-2.5s-1.8-0.7-2.5,0c-2.1,2.1-3.9,6.8,0,10.7 C-232.8,384-232.3,385-232.3,385.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShit);
export default __webpack_public_path__ + "static/media/shit.1c33e23f8ef7ad1e95df7c7facd82098.svg";
export { ForwardRef as ReactComponent };